module.exports = __webpack_public_path__ + "img/portrait-diagnosis.1b3cb875.png";